import React from 'react';
import PropTypes from 'prop-types';
import './StatusIndicator.css';

export const StatusIndicator = (props) => {
  const { state } = props;
  let indicatorClasses = 'status-indicator';

  switch (state) {
    case 'online':
      indicatorClasses += ' status-indicator--online';
      break;
    case 'offline':
      indicatorClasses += ' status-indicator--offline';
      break;
    case 'reset':
      indicatorClasses += ' status-indicator--reset';
      break;
    default:
      indicatorClasses += '';
  }
  return <span className={indicatorClasses} />;
};

StatusIndicator.propTypes = { state: PropTypes.string.isRequired };
